<template src="./WholeMultiselect.html"></template>

<script>
import Multiselect from "vue-multiselect";
export default {
  name: "WholeMultiselect",
  components: { Multiselect },
  props: {
    title: {
      type: String,
      default: ""
    },
    alert: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ""
    },
    showIdAndName: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: false
    },
    showDescription: {
      type: Boolean,
      default: false
    },
    showNameCode: {
      type: Boolean,
      default: false
    },
    value: {
      default: ""
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    trackBy: {
      type: String,
      default: "id"
    },
    defaultLabel: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelField: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    selectValue(select) {
      if (this.labelField) {
        return select[this.labelField]
      }

      const { id, name, text, description, code } = select

      if (this.showIdAndName) {
        return `${id} - ${name}`
      }
      if(this.showText) {
        return text;
      }
      if(this.showDescription) {
        return description
      }
      if(this.showNameCode) {
        return `${name || 'sem nome'} (${code})`
      }
      return name || 'sem nome';
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style src="./WholeMultiselect.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

